import { ErrorCode, StoreRoleForbidden, type ValidationError } from "../errors";

/**
 * Recognises a shop-role refusal (400, `code: "forbidden"`) and turns it into
 * `StoreRoleForbidden`. Call first in the failure mapper of every method whose
 * route is Manager or Owner, before any other `ValidationError` branch.
 */
export function asRoleForbidden(e: ValidationError): StoreRoleForbidden | undefined {
  return e.code === ErrorCode.Forbidden ? new StoreRoleForbidden(e.detailedDesc, e) : undefined;
}
